import type { CollapseProps } from 'antd';
import type { CollapsePanelProps } from 'antd/es/collapse/CollapsePanel';
import type { ReactNode } from 'react';
import { ChevronDown, ChevronRight } from '@styled-icons/boxicons-solid';

import {
  StyledCollapse,
  IconContainer,
  StyledPanel,
  PanelContent,
} from './BigCollapse.styled';

interface BigCollapseProps extends Omit<
  CollapseProps,
  'expandIcon' | 'expandIconPosition' | 'bordered'
> {
  children: ReactNode;
}

interface PanelProps extends CollapsePanelProps {
  children: ReactNode;
}

function BigCollapse({ children, ...props }: BigCollapseProps) {
  return (
    <StyledCollapse
      bordered={false}
      expandIconPosition="end"
      expandIcon={({ isActive }) => (
        <IconContainer>
          {isActive ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </IconContainer>
      )}
      {...props}
    >
      {children}
    </StyledCollapse>
  );
}

function Panel({ children, ...props }: PanelProps) {
  return (
    <StyledPanel {...props}>
      <PanelContent>{children}</PanelContent>
    </StyledPanel>
  );
}

BigCollapse.Panel = Panel;

export default BigCollapse;
